import React from "react";
import { Link } from "react-router-dom";
import Select from 'react-select';
import ShareChildRecord from './ShareChildRecord';
import ShareMedicalRecord from './ShareMedicalRecord';
import {
  Col,
  Row,
  Form,
  FormGroup,
  Label,
  Button
} from "reactstrap";
import "./style.css"
import { getContacts } from "../../services/aboutMe";
import { recordType } from '../configData'
import SharePregnancyRecord from "./SharePregnancyRecord";
import ShareVitals from "./ShareVitals";
import { ContactContext } from './context'
// const records = [
//   { value: "chocolate", label: "Chocolate" },
//   { value: "strawberry", label: "Strawberry" },
//   { value: "vanilla", label: "Vanilla" }
// ];

class ViewSharemyrecord extends React.Component {
  state = {
    contacts: null,
    dropdownLoading: true,
    recordList: [],
    selectedContact: ""
  };

  async componentDidMount() {
    const response = await getContacts();

    const contacts = response.data.contacts.map((contact, index) => {
      return {
        label: contact.name,
        value: contact._id
      }
    });

    this.setState(prevState => ({
      contacts: contacts,
      dropdownLoading: false
    }));
  }

  handleContact = selectedOption => {
    this.setState(prevState => ({ 
      selectedContact: selectedOption['value']
    }));
  };

  handleRecord = selectedOption => {
    this.setState(prevState => ({
      record: selectedOption['value'],
      recordList: []
    }))
  }

  handleCheckbox = (event, recordId) => {
    let checked = event.target.checked;
    let { recordList } = this.state;
    const index = recordList.indexOf(recordId);
    if(checked == true) {
      if(index < 0) {
        recordList.push(recordId);
      }
    } else {
      if(index >= 0) {
        recordList.splice(index, 1)
      } 
    }

    this.setState(prevState => ({
      recordList: [...recordList]
    }))
  }

  renderForm = () => {
    const { record } = this.state;
    
    if(record == 0) {
      return <SharePregnancyRecord />
    } else if(record == 1) {
      return <ShareChildRecord />
    } else if(record == 2) {
      return <ShareMedicalRecord />
    } else if(record == 3) {
      return <ShareVitals />
    }
  }

  render() {
    const { dropdownLoading, contacts, selectedContact, record } = this.state;
    return (
      <div className="pt-3">
        <Form>
          <Row>
            <Col xs="12" md={{ size: 4 }}>
              <FormGroup>
                <Label>Share With</Label>
                <Select
                  options={contacts}
                  onChange={this.handleContact}
                  isLoading={dropdownLoading}
                />
              </FormGroup>
            </Col>
            <Col xs="12" md={{ size: 4 }}>
              <Button
                className=""
                style={{ marginTop: "30px" }}
                tag={Link}
                to={"/profile"}
              >
                Add Contact
              </Button>
            </Col>
          </Row>
          <Row>
            <Col className="col-md-4">
              <FormGroup>
                <Label>Select Record</Label>
                <Select 
                  options={recordType}
                  onChange={this.handleRecord}
                />
              </FormGroup>
              {/* <hr /> */}
            </Col>
            <ContactContext.Provider value={{contact: selectedContact, model: record} }>
              {this.renderForm()}
            </ContactContext.Provider>
          </Row>
          <Row>
            {/* <Col sm="12" md={{ size: 4 }}>
              <Label>Record Type</Label>

              <Input
                value={selectedOption}
                type="select"
                name="recordtype"
                onChange={this.handleChange}
              >
                <option>Thyroid</option>
                <option>Blood Sugar</option>
                <option>Blood Pressure</option>
              </Input>
            </Col> */}
          </Row>
          {/* <Row>
            <Table>
              <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Date</th>
                <th>Hospital</th>
                <th>Doctor</th>
                <th>Select</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>1</td>
                <td>Reports</td>
                <td>26-06-18</td>
                <td>Max Hospital</td>
                <td>Rajeev Shukla</td>
                <td>
                  <input type="radio" />
                </td>
              </tr>
              </tbody>
            </Table>
          </Row> */}
        </Form>
      </div>
    );
  }
}

export default ViewSharemyrecord;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareMyRecord/ViewSharemyrecord.js